import { api } from './BaseService'

export const getUnits = async () => {
    const res= await api.get(`/units`)
    return res
}

export const getUnitById = async (id) => {
    return await api.get(`/units/${id}`)
}

export const createUnit = async (data) => {
    return await api.post(`/units`, data)
}
export const updateUnit = async (data) => {
    return await api.put(`/units/${data?.id}`, data)
}
export const deleteUnit = async (id) => {
    return await api.delete(`/units/${id}`)
}
